.spinner-three-bounce[data-spinner] {
  position: absolute;
  margin: 0 auto;
  width: 70px;
  text-align: center;
  z-index: 999;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  /* center vertically */
  top: 50%;
  transform: translateY(-50%);

  &> div {
    width: 18px;
    height: 18px;
    background-color: #FFFFFF;
    border-radius: 100%;
    display: inline-block;
    animation: bouncedelay 1.4s infinite ease-in-out;
    /* Prevent first frame from flickering when animation starts */
    animation-fill-mode: both;
  }

  [data-bounce1] {
    animation-delay: -0.32s;
  }

  [data-bounce2] {
    animation-delay: -0.16s;
  }
}

@keyframes bouncedelay {
  0%, 80%, 100% { transform: scale(0.0); }
  40% { transform: scale(1.0); }
}
